import { forwardRef } from 'react';
import { cn } from '@/utils/cn';
import { Loader2 } from 'lucide-react';

const buttonVariantsConfig = {
  base: 'inline-flex items-center justify-center rounded-xl font-bold uppercase transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-zinc-900 focus:ring-indigo-500 disabled:opacity-50 disabled:pointer-events-none active:scale-95',
  variants: {
    variant: {
      default: 'bg-indigo-600 text-white hover:bg-indigo-500 shadow-lg shadow-indigo-500/20',
      destructive: 'bg-red-600 text-white hover:bg-red-500 shadow-[0_0_20px_rgba(220,38,38,0.2)]',
      'primary-outline': 'bg-indigo-600/10 border border-indigo-500/20 text-indigo-400 hover:bg-indigo-600 hover:border-indigo-500 hover:text-white shadow-lg hover:shadow-indigo-500/20',
      'destructive-outline': 'bg-transparent border border-red-900/20 text-red-500 hover:bg-red-500 hover:text-white',
      success: 'bg-emerald-600 text-white hover:bg-emerald-500 shadow-[0_0_20px_rgba(16,185,129,0.2)]',
      secondary: 'bg-zinc-800/50 hover:bg-zinc-700/80 border border-zinc-700/50 text-zinc-300 hover:text-white',
      ghost: 'text-zinc-500 hover:text-white',
      link: 'text-indigo-400 hover:text-indigo-300 underline underline-offset-4 !normal-case !tracking-normal',
    },
    size: {
      default: 'py-3 px-8 text-xs tracking-widest',
      sm: 'py-2 px-4 text-[10px] tracking-widest',
      lg: 'py-4 text-xs tracking-widest',
      icon: 'h-10 w-10',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
};

const Button = forwardRef(({ className, variant, size, loading = false, children, ...props }, ref) => {
  return (
    <button
      className={cn(
        buttonVariantsConfig.base,
        buttonVariantsConfig.variants.variant[variant || buttonVariantsConfig.defaultVariants.variant],
        buttonVariantsConfig.variants.size[size || buttonVariantsConfig.defaultVariants.size],
        className
      )}
      ref={ref}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export { Button };